var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",class:{ double: _vm.double, triple: _vm.triple, operation: _vm.operation },on:{"click":function () { return _vm.onClick(_vm.label); }}},[_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }